var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data)?_c('country-flag',{staticClass:"flag",attrs:{"country":_vm.data,"size":_vm.size}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }